import Player from "@vimeo/player";

import AOS from "aos";

AOS.init();

const body = document.querySelector("body");

const toggleMenuBtn = document.querySelectorAll(".toggle-menu");

if (toggleMenuBtn.length) {
  for (let index = 0; index < toggleMenuBtn.length; index++) {
    toggleMenuBtn[index].addEventListener("click", () => {
      body.classList.toggle("show-menu");
      toggleMenuBtn.classList.toggle("is-active");
    });
  }
}

const openSendBriefBtn = document.querySelector(".open-send-brief");
const closeSendBriefBtn = document.querySelector(".close-send-brief");

if (openSendBriefBtn) {
  openSendBriefBtn.addEventListener("click", () => {
    body.classList.toggle("show-brief");
    openSendBriefBtn.classList.toggle("is-active");
  });
}

if (closeSendBriefBtn) {
  closeSendBriefBtn.addEventListener("click", () => {
    body.classList.toggle("show-brief");
    openSendBriefBtn.classList.toggle("is-active");
  });
}

const vimeoAutoplay = document.querySelector("iframe.autoplay");

if (vimeoAutoplay) {
  const player = new Player(vimeoAutoplay);
  const loading = document.querySelector(".loading");

  player.on("play", function () {
    loading.classList.add("lg:hidden");
  });
}

const toggleVimeoAudio = document.querySelector(".vimeo-audio");

if (toggleVimeoAudio) {
  const player = new Player(vimeoAutoplay);

  const audioHigh = document.querySelector(".vimeo-audio .high");
  const audioLow = document.querySelector(".vimeo-audio .low");

  toggleVimeoAudio.addEventListener("click", async () => {
    const muted = await player.getMuted();

    muted ? player.setMuted(false) : player.setMuted(true);

    audioHigh.classList.toggle("hidden");
    audioLow.classList.toggle("hidden");
  });
}

const scrollPage = document.querySelector(".scroll-page");

const scrollDown = () => {
  if (scrollPage) {
    scrollPage.addEventListener("click", () => {
      window.scroll({
        top: window.innerHeight / 2,
      });
    });
  }
};

scrollDown();

const footer = document.querySelector("footer");

window.addEventListener("scroll", (x) => {
  if (
    window.innerHeight + window.scrollY >=
    document.body.offsetHeight - footer.clientHeight
  ) {
    openSendBriefBtn.classList.add("!hidden");
  } else {
    openSendBriefBtn.classList.remove("!hidden");
  }
});

jQuery(function ($) {
  const width = $(window).width();

  if (width < 1024) {
    $(".sub-menu").hide();

    $("li.menu-item-has-children a").on("click", (e) => {
      // e.preventDefault();
      $(this).find(".sub-menu").toggle(); // display child
    });
  }
});
